<template>
  <q-form v-on="computedListeners" v-bind="$attrs" ref="form">
    <i-filters @search="$refs.form.submit()" @reset="$refs.form.reset()" :search-loading="searchLoading"
          :search-disable="searchDisable" :reset-loading="resetLoading" :reset-disable="resetDisable">
      <i-field v-for="field of computedFields" :key="field.name" :value="value[field.name]" @input="onFieldInput(field.name, arguments[0])"
        v-bind="field.attrs" v-on="field.on" />
      <div v-if="!hideActions" class="app-page-filters-form-actions">
        <i-btn type="submit" size="lg" color="action-get" icon="search" label="查询" />
        <i-btn type="reset" size="lg" color="action-reset" icon="undo" label="重置" />
      </div>
    </i-filters>
    <!--icon="filter_alt" label="过滤条件"-->
  </q-form>
</template>
<script>
import _ from 'lodash'
export default {
  props: {
    fields: {
      required: true,
      type: Array
    },
    value: {
      required: true,
      type: [Object, InputEvent],
      validator (val) {
        return !!val
      }
    },
    hideActions: {
      type: Boolean,
      default: true
    },
    searchLoading: Boolean,
    searchDisable: Boolean,
    resetLoading: Boolean,
    resetDisable: Boolean
  },
  computed: {
    computedFields () {
      return this.fields?.filter(item => !item.hidden)
    },
    computedListeners () {
      return _.omit(this.$listeners, ['input'])
    }
  },
  methods: {
    onFieldInput (fieldName, value) {
      this.$emit('input', { ...this.value, [fieldName]: value })
    },
    validate () {
      return this.$refs.form.validate()
    },
    submit () {
      return this.$refs.form.submit()
    },
    resetValidation () {
      return this.$refs.form.resetValidation()
    },
    reset () {
      return this.$refs.form.reset()
    }
  }

}
</script>
